import { Assessment as AssessmentIcon, Business as BusinessIcon, Group as GroupIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { Box, Button, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import React from 'react';

const HomeScreen: React.FC = () => {
    return (
        <Box>
            {/* Hero Section */}
            <Box
                sx={{
                    textAlign: 'center',
                    py: 12,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: '#fff',
                    mb: 8,
                }}
            >
                <Container maxWidth="lg">
                    <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                        AI Solutions
                    </Typography>
                    <Typography variant="h5" component="p" sx={{ mb: 4, opacity: 0.9 }}>
                        Providing AI, Data Science, and Machine Learning Solutions
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        sx={{
                            backgroundColor: '#fff',
                            color: '#1565c0',
                            px: 4,
                            py: 1.5,
                            fontSize: '1.1rem',
                            fontWeight: 'bold',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: '#f5f5f5',
                            },
                        }}
                    >
                        Schedule Consultation
                    </Button>
                </Container>
            </Box>

            {/* Services Preview */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Typography
                    variant="h3"
                    component="h2"
                    textAlign="center"
                    gutterBottom
                    sx={{ fontWeight: 'bold', mb: 6 }}
                >
                    Our Services
                </Typography>
                <Grid container spacing={4}>
                    {[
                        {
                            icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
                            title: 'Strategy Consulting',
                            description: 'Develop winning strategies that position your business for sustainable growth.',
                        },
                        {
                            icon: <AssessmentIcon sx={{ fontSize: 40 }} />,
                            title: 'Digital Transformation',
                            description: 'Navigate the digital landscape with comprehensive transformation programs.',
                        },
                        {
                            icon: <GroupIcon sx={{ fontSize: 40 }} />,
                            title: 'Operations Excellence',
                            description: 'Optimize operations to achieve peak efficiency and customer value.',
                        },
                        {
                            icon: <BusinessIcon sx={{ fontSize: 40 }} />,
                            title: 'Change Management',
                            description: 'Lead successful organizational change with proven methodologies.',
                        },
                    ].map((service, index) => (
                        <Grid size={{ xs: 12, sm: 6 }} key={index}>
                            <Card
                                sx={{
                                    height: '100%',
                                    transition: 'transform 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: 6,
                                    },
                                }}
                            >
                                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                                    <Box sx={{ color: '#1565c0', mb: 2 }}>
                                        {service.icon}
                                    </Box>
                                    <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                                        {service.title}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        {service.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default HomeScreen;